import React, { useCallback } from 'react';
import { Container, Row } from 'react-bootstrap';
function OpenEndedComments({ candidate, asPage = false, allComments = false, strengths, start = 0, end = 0 }) {
  const getContents = useCallback(() => {
    if (!candidate) {
      return <></>;
    }

    let paddingTop = 'pt-5';
    if (asPage) {
      paddingTop = 'pt-3';
    }
    const displayFull = allComments || !asPage;
    const classes = `w-100 justify-content-left ${paddingTop} pb-4`;
    // noinspection JSValidateTypes
    return (
      <Row className={classes}>
        <h4>Open Ended Comments</h4>
        {(displayFull || strengths) && (
          <>
            <h5 className="mt-3">What is this person&#39;s greatest strength? {start > 0 ? '(continued)' : ''}</h5>
            {candidate.selfCompetencies?.scores.greatestStrengthCollection.map((comment, index) => {
              if (displayFull || (index >= start && index < end)) {
                return <div key={Math.random()}>&#x2022; {comment}</div>;
              }
            })}
          </>
        )}
        {(displayFull || !strengths) && (
          <>
            <h5 className="mt-3">
              What is this person&#39;s greatest opportunity for improvement? {start > 0 ? '(continued)' : ''}
            </h5>
            {candidate.selfCompetencies?.scores.opportunityForImprovementCollection.map((comment, index) => {
              if (displayFull || (index >= start && index < end)) {
                return <div key={Math.random()}>&#x2022; {comment}</div>;
              }
            })}
          </>
        )}
      </Row>
    );
  }, [candidate, strengths, start, end, asPage]);

  return (
    <>
      {!asPage ? (
        <>{getContents()}</>
      ) : (
        <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
          <Container className="candidate-profile-assessment-content">
            <Row className="w-100 justify-content-left">
              <h3 className="pt-4 pb-1">COMPETENCIES</h3>
              {getContents()}
            </Row>
          </Container>
        </Container>
      )}
    </>
  );
}

export default OpenEndedComments;
